var React = require('react');

function Fork (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"current","d":"M12 21a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zm-3.25-1.75a3.25 \n  3.25 0 106.5 0 3.25 3.25 0 00-6.5 0zm-3-12.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM2.5 \n  4.75a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0zM18.25 6.5a1.75 1.75 0 110-3.5 1.75 1.75 0 \n  010 3.5zM15 4.75a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0z","key":0}),React.createElement("path",{"fill":"current","d":"M6.5 7.75v1A2.25 2.25 0 008.75 11h6.5a2.25 2.25 0 002.25-2.25v-1H19v1a3.75 \n  3.75 0 01-3.75 3.75h-6.5A3.75 3.75 0 015 8.75v-1h1.5z","key":1}),React.createElement("path",{"fill":"current","d":"M11.25 16.25v-5h1.5v5h-1.5z","key":2})]);
}

Fork.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Fork;

Fork.default = Fork;
